import React, { useState, useEffect } from 'react';
import { Card, Switch, Spin, message, Alert, Input, Button, Row, Col, Select, Typography, Divider } from 'antd';
import { GiftOutlined, MessageOutlined, DesktopOutlined, SaveOutlined } from '@ant-design/icons';
import { adminAPI } from '../api/admin';

const { TextArea } = Input;
const { Title, Paragraph, Text } = Typography;

export default function BirthdayGreetingManager() {
  const [settings, setSettings] = useState({
    enabled: false,
    smsEnabled: true,
    siteEnabled: true,
    smsTemplate: '',
    siteTemplate: '',
    giftProductEnabled: false,
    giftProductId: null
  });
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setLoading(true);
    try {
      const [configRes, productsRes] = await Promise.all([
        adminAPI.getAppConfig('birthday_settings'),
        adminAPI.getRequirements() // gets all requirements/items
      ]);

      if (configRes.data.success && configRes.data.config) {
        setSettings(configRes.data.config.value);
      }
      
      if (productsRes.data.success) {
        // filter active products
        const activeProducts = productsRes.data.requirements || [];
        setProducts(activeProducts.filter(p => p.isActive));
      }
    } catch (error) {
      message.error('خطا در بارگذاری اطلاعات تنظیمات تولد');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const response = await adminAPI.upsertAppConfig('birthday_settings', settings);
      if (response.data.success) {
        message.success('تنظیمات تبریک تولد با موفقیت ذخیره شد');
      }
    } catch (error) {
      message.error('خطا در ذخیره تنظیمات');
      console.error(error);
    } finally {
      setSaving(false);
    }
  };

  const handleFieldChange = (key, value) => {
    setSettings(prev => ({
      ...prev,
      [key]: value
    }));
  };

  if (loading) return <Spin size="large" style={{ display: 'block', margin: '48px auto' }} />;

  return (
    <div style={{ maxWidth: 800, margin: '0 auto', display: 'flex', flexDirection: 'column', gap: 24 }}>
      <Card 
        title={
          <span style={{ fontSize: 18, fontWeight: 600 }}>
            <GiftOutlined style={{ marginInlineEnd: 8, color: '#722f37' }} />
            سیستم خودکار تبریک تولد کاربران
          </span>
        }
        bordered={false}
        className="birthday-settings-card"
      >
        <Alert
          type="info"
          showIcon
          style={{ marginBottom: 24 }}
          message="جشن تولد جادویی برای پاترهدها"
          description="با فعال کردن این سیستم، کاربران یک روز قبل از تاریخ تولد خود پیامک تبریک دریافت کرده و در روز تولدشان به محض ورود به سایت، پیام خوش‌آمدگویی جادویی همراه با افکت‌های جذاب و هدیه دیجیتالی دریافت خواهند کرد."
        />

        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
          <div>
            <div style={{ fontWeight: 600, fontSize: 16 }}>فعال‌سازی کل سیستم تبریک تولد</div>
            <div style={{ color: '#888', fontSize: 13 }}>توقف یا راه‌اندازی کل مکانیسم ارسال پیامک و نمایش پاپ‌آپ تبریک تولد</div>
          </div>
          <Switch 
            checked={settings.enabled} 
            onChange={(checked) => handleFieldChange('enabled', checked)} 
          />
        </div>

        {settings.enabled && (
          <>
            <Divider orientation="left">کانال‌های تبریک</Divider>
            
            <Row gutter={[24, 24]}>
              <Col xs={24} md={12}>
                <Card 
                  type="inner"
                  title={
                    <span>
                      <MessageOutlined style={{ marginInlineEnd: 8, color: '#1890ff' }} />
                      تنظیمات پیامک (یک روز قبل)
                    </span>
                  }
                  extra={
                    <Switch 
                      size="small" 
                      checked={settings.smsEnabled} 
                      onChange={(checked) => handleFieldChange('smsEnabled', checked)} 
                    />
                  }
                >
                  <div style={{ marginBottom: 12 }}>
                    <Text strong>متن پیامک تبریک:</Text>
                    <TextArea 
                      rows={5} 
                      disabled={!settings.smsEnabled}
                      value={settings.smsTemplate}
                      onChange={(e) => handleFieldChange('smsTemplate', e.target.value)}
                      placeholder="متن پیامک تبریک تولد را وارد کنید..."
                      style={{ marginTop: 8 }}
                    />
                  </div>
                </Card>
              </Col>

              <Col xs={24} md={12}>
                <Card 
                  type="inner"
                  title={
                    <span>
                      <DesktopOutlined style={{ marginInlineEnd: 8, color: '#52c41a' }} />
                      تبریک داخل سایت (روز تولد)
                    </span>
                  }
                  extra={
                    <Switch 
                      size="small" 
                      checked={settings.siteEnabled} 
                      onChange={(checked) => handleFieldChange('siteEnabled', checked)} 
                    />
                  }
                >
                  <div style={{ marginBottom: 12 }}>
                    <Text strong>پیام داخل سایت:</Text>
                    <TextArea 
                      rows={5} 
                      disabled={!settings.siteEnabled}
                      value={settings.siteTemplate}
                      onChange={(e) => handleFieldChange('siteTemplate', e.target.value)}
                      placeholder="متن پیام پاپ‌آپ داخل سایت را وارد کنید..."
                      style={{ marginTop: 8 }}
                    />
                  </div>
                </Card>
              </Col>
            </Row>

            <Divider orientation="left">هدیه تولد جادویی (محصول دیجیتالی)</Divider>

            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
              <div>
                <div style={{ fontWeight: 600 }}>اهدای محصول دیجیتالی رایگان به عنوان هدیه</div>
                <div style={{ color: '#888', fontSize: 13 }}>به عنوان هدیه تولد، محصول انتخاب شده به طور خودکار به وسایل خریداری شده کاربر اضافه می‌شود.</div>
              </div>
              <Switch 
                checked={settings.giftProductEnabled} 
                onChange={(checked) => handleFieldChange('giftProductEnabled', checked)} 
              />
            </div>

            {settings.giftProductEnabled && (
              <div style={{ marginBottom: 24 }}>
                <div style={{ fontWeight: 600, marginBottom: 8 }}>انتخاب محصول دیجیتالی:</div>
                <Select
                  showSearch
                  style={{ width: '100%' }}
                  placeholder="یک محصول را از وسایل مدرسه انتخاب کنید..."
                  optionFilterProp="children"
                  value={settings.giftProductId}
                  onChange={(val) => handleFieldChange('giftProductId', val)}
                  filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                  }
                  options={products.map(p => ({
                    value: p._id,
                    label: `${p.farsiName || p.name} (سال ${p.schoolYear || 1} - ${p.priceGalleons} گالیون)`
                  }))}
                />
              </div>
            )}

            <Card style={{ backgroundColor: '#fafafa', border: '1px dashed #d9d9d9', borderRadius: 8 }}>
              <Title level={5} style={{ marginTop: 0 }}>راهنمای متغیرهای پویا:</Title>
              <Paragraph style={{ marginBottom: 0 }}>
                می‌توانید از متغیرهای زیر در متن پیامک یا داخل سایت استفاده کنید تا به صورت خودکار با اطلاعات کاربر جایگزین شوند:
                <ul>
                  <li><Text code>{'{firstName}'}</Text>: نام کوچک کاربر (مثال: هری)</li>
                  <li><Text code>{'{lastName}'}</Text>: نام خانوادگی کاربر (مثال: پاتر)</li>
                  <li><Text code>{'{fullName}'}</Text>: نام و نام خانوادگی کامل کاربر</li>
                  <li><Text code>{'{giftName}'}</Text>: نام محصول هدیه داده شده</li>
                  <li><Text code>{'{giftLink}'}</Text>: لینک دانلود یا دسترسی به محصول دیجیتالی هدیه</li>
                </ul>
              </Paragraph>
            </Card>
          </>
        )}

        <div style={{ marginTop: 24, display: 'flex', justifyContent: 'flex-end' }}>
          <Button 
            type="primary" 
            icon={<SaveOutlined />} 
            loading={saving} 
            onClick={handleSave}
            size="large"
            style={{ backgroundColor: '#722f37', borderColor: '#722f37' }}
          >
            ذخیره تنظیمات
          </Button>
        </div>
      </Card>
    </div>
  );
}
